export default __webpack_public_path__ + "media/images/mastheads/branded-new-1c14558064576fb34aab7dc2bd8ea3c9.jpg";